import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const CaseStudyIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.3385 5.65574V16.7738H1.66147L1.66147 3.80273L6.75724 3.80273L8.61024 5.65574L18.3385 5.65574Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.48962 4.63088L2.48962 15.9457H17.5104V6.48389H8.61025C8.39062 6.48389 8.17998 6.39664 8.02467 6.24133L6.41422 4.63088L2.48962 4.63088ZM1.66148 2.97461L6.75725 2.97461C6.97688 2.97461 7.18752 3.06186 7.34283 3.21717L8.95328 4.82762L18.3385 4.82762C18.5582 4.82762 18.7688 4.91487 18.9241 5.07017C19.0794 5.22548 19.1667 5.43612 19.1667 5.65575V16.7738C19.1667 17.2312 18.7959 17.6019 18.3385 17.6019H1.66148C1.20411 17.6019 0.833344 17.2312 0.833344 16.7738L0.833344 3.80275C0.833344 3.34538 1.20411 2.97461 1.66148 2.97461Z"
        fill="currentColor"
      />
      <path
        d="M18.3385 4.34776V15.4658H1.66147L1.66147 2.49475L6.75724 2.49475L8.61024 4.34776L18.3385 4.34776Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.48962 3.3229L2.48962 14.6377H17.5104V5.17591H8.61025C8.39062 5.17591 8.17998 5.08866 8.02467 4.93335L6.41422 3.3229L2.48962 3.3229ZM1.66148 1.66663L6.75725 1.66663C6.97688 1.66663 7.18752 1.75388 7.34283 1.90918L8.95328 3.51963L18.3385 3.51963C18.5582 3.51963 18.7688 3.60688 18.9241 3.76219C19.0794 3.91749 19.1667 4.12813 19.1667 4.34777V15.4658C19.1667 15.9232 18.7959 16.2939 18.3385 16.2939H1.66148C1.20411 16.2939 0.833344 15.9232 0.833344 15.4658L0.833344 2.49476C0.833344 2.0374 1.20411 1.66663 1.66148 1.66663Z"
        fill="currentColor"
      />
      <path
        d="M7.02062 12.0713C5.2989 12.0713 3.78249 13.0077 2.89569 14.4284H11.1456C10.2588 13.0077 8.74235 12.0713 7.02062 12.0713Z"
        fill="var(--cdl-chart-red-base)"
      />
      <path
        d="M9.77058 9.32137C9.77058 10.8401 8.53938 12.0713 7.02062 12.0713C5.50186 12.0713 4.27067 10.8401 4.27067 9.32137C4.27067 7.80261 5.50186 6.57141 7.02062 6.57141C8.53938 6.57141 9.77058 7.80261 9.77058 9.32137Z"
        fill="var(--cdl-chart-red-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.02064 6.80187C5.6292 6.80187 4.50121 7.92986 4.50121 9.3213C4.50121 10.7127 5.6292 11.8407 7.02064 11.8407C8.41208 11.8407 9.54007 10.7127 9.54007 9.3213C9.54007 7.92986 8.41208 6.80187 7.02064 6.80187ZM8.30565 12.0113C9.30847 11.5314 10.0011 10.5072 10.0011 9.3213C10.0011 7.67523 8.66671 6.34082 7.02064 6.34082C5.37457 6.34082 4.04016 7.67523 4.04016 9.3213C4.04016 10.5072 4.73281 11.5314 5.73563 12.0113C4.47285 12.3536 3.39796 13.1883 2.70015 14.3063L2.48007 14.6589H11.5612L11.3411 14.3063C10.6433 13.1883 9.56843 12.3536 8.30565 12.0113ZM7.02064 12.3018C5.53193 12.3018 4.19974 13.0389 3.33254 14.1978H10.7087C9.84154 13.0389 8.50935 12.3018 7.02064 12.3018Z"
        fill="var(--cdl-chart-red-base)"
      />
    </svg>
  );
};

export default CaseStudyIcon;
